// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */
/* ==========================================================================
Main page styles
========================================================================== */
.hipster {
  display: inline-block;
  width: 100%;
  height: 497px;
  background: url("/content/images/logo.png") no-repeat center top;
  background-size: contain;
}

.alert-warning {
  --bs-alert-color: white;
  --bs-alert-bg: #ffce67;
  --bs-alert-border-color: #fff0d1;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/home/home.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAAA;AAiBA;;4EAAA;AAGA;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,gEAAA;EACA,wBAAA;AAAF;;AAEA;EACE,uBAAA;EACA,sBAAA;EACA,gCAAA;AACF","sourcesContent":["/*!\n *\n *\n *\n *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.\n *   This file is part of the API module  of the project: TinyMedic-Platform.\n *\n *\n *   Proprietary and confidential.\n *\n *   Unauthorized copying of this file, via any medium is strictly prohibited.\n *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.\n *\n *\n *\n */\n\n/* ==========================================================================\nMain page styles\n========================================================================== */\n.hipster {\n  display: inline-block;\n  width: 100%;\n  height: 497px;\n  background: url('/content/images/logo.png') no-repeat center top;\n  background-size: contain;\n}\n.alert-warning {\n  --bs-alert-color: white;\n  --bs-alert-bg: #ffce67;\n  --bs-alert-border-color: #fff0d1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
